// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MediaMessageImage__container-dd7cab {
  position: relative;
  min-width: 100px;
  min-height: 100px;
  border-radius: 16px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  user-select: none;
}

.MediaMessageImage__backdrop-e2f788 {
  position: absolute;
  width: 100%;
  height: 100%;
  background-size: cover;
  border-radius: 16px;
  filter: blur(5px);
}

@supports (backdrop-filter: blur(5px)) {
  .MediaMessageImage__backdrop-e2f788 {
    filter: none;
  }
  .MediaMessageImage__backdrop-e2f788:after {
    content: "";
    position: absolute;
    width: 100%;
    height: 100%;
    border-radius: 16px;
    backdrop-filter: blur(5px);
  }
}
.MediaMessageImage__container-dd7cab:hover .MediaMessageImage__delete-aebe08 {
  opacity: 1;
}

.MediaMessageImage__image-eea428 {
  max-width: 100%;
  height: auto;
  max-height: 392px;
  position: relative;
  background-color: var(--base-10);
}`, "",{"version":3,"sources":["webpack://./src/main/PopupManager/Popups/MediaMessagePopup/ItemMedia/MediaMessageImage/MediaMessageImage.styles.m.css"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;AACF;;AAEA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,mBAAA;EACA,iBAAA;AACF;;AAEA;EACE;IACE,YAAA;EACF;EACA;IACE,WAAA;IACA,kBAAA;IACA,WAAA;IACA,YAAA;IACA,mBAAA;IACA,0BAAA;EACF;AACF;AAEA;EACE,UAAA;AAAF;;AAGA;EACE,eAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,gCAAA;AAAF","sourcesContent":[".container {\n  position: relative;\n  min-width: 100px;\n  min-height: 100px;\n  border-radius: 16px;\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  user-select: none;\n}\n\n.backdrop {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  background-size: cover;\n  border-radius: 16px;\n  filter: blur(5px);\n}\n\n@supports (backdrop-filter: blur(5px)) {\n  .backdrop {\n    filter: none;\n  }\n  .backdrop:after {\n    content: '';\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    border-radius: 16px;\n    backdrop-filter: blur(5px);\n  }\n}\n\n.container:hover .delete {\n  opacity: 1;\n}\n\n.image {\n  max-width: 100%;\n  height: auto;\n  max-height: 392px;\n  position: relative;\n  background-color: var(--base-10);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `MediaMessageImage__container-dd7cab`,
	"backdrop": `MediaMessageImage__backdrop-e2f788`,
	"delete": `MediaMessageImage__delete-aebe08`,
	"image": `MediaMessageImage__image-eea428`
};
module.exports = ___CSS_LOADER_EXPORT___;
